import { render } from "./BagsizeDialog.vue?vue&type=template&id=321ff04a&scoped=true&ts=true"
import script from "./BagsizeDialog.vue?vue&type=script&lang=ts"
export * from "./BagsizeDialog.vue?vue&type=script&lang=ts"

import "./BagsizeDialog.vue?vue&type=style&index=0&id=321ff04a&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321ff04a"]])

export default __exports__